
import axios from 'axios';
import cookies from 'vue-cookies';
import $screen from 'vue-screen';
import router from '@/router/index';

import Helper from '@/lib/langTemplates/HelperClauses';

const baseUrl = 'https://3eunx8rcp7.execute-api.eu-west-1.amazonaws.com/dev/';

let headers = {
  'Content-Type': 'application/json',
  Authorization: cookies.get('breeziProTkn')
}

const Rest = {

  state: {

  },

  mutations: {

  },

  actions: {

    async postRoom(context, newRoom){
      newRoom.device = newRoom.deviceId;
      newRoom.altSize = `${newRoom.length}x${newRoom.width}x${newRoom.depth}`;
      newRoom.breakpoint = breakpoint;
      newRoom.buildingId = context.rootState.activeBuilding.id;
      newRoom.floorIndex = newRoom.fIndex;
      ['deviceId', 'length', 'width', 'depth', 'fIndex'].forEach(i => delete newRoom[i]);
      let url = `${baseUrl}rooms`;
      const packet = context.rootState.onboard.obPacket;
      const breakpoint = newRoom.breakpoint;
      delete newRoom.breakpoint;
      try {
        const room = (await axios.post(url, JSON.stringify(newRoom), {headers: headers})).data;
        room.breakpoint = breakpoint;
        context.dispatch('updateRoom', room);
      } catch(err) {
        console.log(err);
        context.dispatch('initNotif', {
          type: 'err',
          title: Helper.clauses.roomAddFail[`${context.rootState.lang}Title`],
          body: Helper.clauses.roomAddFail[context.rootState.lang]
        });
      }
    },

    updateRoom(context, room){
      try {
        const breakpoint = room.breakpoint;
        delete room.breakpoint;
        room = formatRoom(room);
        let floor = context.rootState.activeFloor.info
          ? context.rootState.activeFloor
          : {info: {index: room.info.floorIndex, name: `Floor ${room.info.floorIndex}`}, rooms: []};
        floor = addChildAndAlerts(floor, room, 'rooms', context.rootState.activeFloor.info ? false : true);
        let bldg = context.rootState.activeBuilding;
        bldg = addChildAndAlerts(bldg, floor, 'floors', context.rootState.activeFloor.info ? false : true);
        let org = {buildings: context.rootState.buildings};
        org = addChildAndAlerts(org, bldg, 'buildings');
        const {buildings, alerts, overall} = org;
        const hierarchy = {
          activeRoom: room,
          activeFloor: floor,
          activeBuilding: bldg,
          buildings: buildings,
          alerts: alerts,
          overallAlerts: overall,
          breakpoint: breakpoint
        };
        context.commit('updateHierarchy', hierarchy);
      } catch(err) {
        console.log(err);
        context.dispatch('initNotif', {
          type: 'err',
          title: 'Update Error',
          body: `The room was successfully added, but we were unable to reset your organization's data schema. You will be logged out automatically and, when you log back in, the room should be added.`
        });
        router.push({path: '/'});
      }
    },

    async postBuilding(context, newBldg){
      try {
        const posted = (await(axios.post(baseUrl + 'buildings', JSON.stringify(newBldg), {
          headers: headers
        }))).data;
        const bId = posted.split(' ')[1];
        const url = `${baseUrl}bundle/${bId}`
        const bldg = (await axios.get(url, {headers: headers})).data;
        context.dispatch('updateBldg', bldg);
      } catch(err) {
        throw err;
        context.dispatch('loadingOff');
      }
    },

    updateBldg(context, bldg){
      context.commit('')
      // let org = {buildings: context.rootState.buildings};
      // org = addChildAndAlerts(org, bldg, 'buildings', true);
      // const {buildings, alerts, overall} = org;
      // const hierarchy = {activeBuilding: bldg, buildings: buildings, alerts: alerts, overallAlerts: org.overallAlerts};
      // context.commit('updateHierarchy', hierarchy);
    },

    // async deleteRoom(context, did){
    //   const url = `${baseUrl}rooms/${did}`;
    //   const headers = {
    //     'Content-Type': 'application/json',
    //     Authorization: cookies.get('breeziProTkn')
    //   }
    //   try {
    //     await axios.delete(url, {headers: headers});
    //     context.dispatch('removeRoom', did);
    //   } catch(err) {
    //     console.log({ERROR: err});
    //     context.dispatch('initNotif', {
    //       type: 'err',
    //       title: 'Delete Failed',
    //       body: `We were unable to remove the room from your account.  Please log out and back in to reset your session, then try again.`
    //     })
    //   }
    // },

    removeRoom(context, did){
      const room = context.rootState.activeFloor.rooms.find(r => r.did === did);
      const floor = removeChildUpdateAlerts(context.rootState.activeFloor, room, 'rooms');
      let bldg;
      if (!floor.rooms.length) {
        bldg = removeChildUpdateAlerts(context.rootState.activeBuilding, floor, 'floors');
      } else {
        bldg = context.rootState.activeBuilding;
        const bFloor = bldg.floors.find(f => f.info.index === floor.info.index);
        const fIndex = bldg.floors.indexOf(bFloor);
        bldg.floors[fIndex] = floor;
      }
      let org = {buildings: context.rootState.buildings};
      org = addChildAndAlerts(org, bldg, 'buildings');
      let hierarchy = {
        activeBuilding: bldg,
        buildings: org.buildings,
        alerts: org.alerts,
        overallAlerts: org.overallAlerts
      };
      if (floor.rooms.length) hierarchy.activeFloor = floor;
      context.commit('updateHierarchy', hierarchy);
    },

    async toggleTutorial(context){
      const headers = {
        'Content-Type': 'application/json',
        Authorization: cookies.get('breeziProTkn')
      }
      context.dispatch('loadingOn');
      const params = {
        url: `${baseUrl}language?tutorial=${context.rootState.user.tutorial ? false : true}`,
        headers: {headers: headers}
      }
      try {
        await axios.post(params.url, {}, {headers: headers});
        context.commit('toggleStateTutorial', context.rootState.user.tutorial ? false : true);
        context.dispatch('loadingOff');
      } catch(err) {
        context.dispatch('initNotif', {
          type: 'err',
          title: "Unable to Update",
          body: "An error occurred attempting to update your tutorial preference. Please try again and, if the issue persists, contact support@breezi.io"
        });
        context.dispatch('loadingOff');
      }
    }

  }

}

export default Rest;

function cascadeHierarchy(newEntity, type, ...conditionals){
  switch (type) {
    case 'bldg':

    break;
    case 'room':
    break;
    case 'delBldg':
    break;
    case 'delRoom':
    break;
    case 'refresh':
    break;
    case 'changeFilter':
    break;
  }
}

function addChildAndAlerts(parent, child, list, nova){
  if (nova) {
    parent[list].push(child);
  } else {
    let existing;
    if (list === 'rooms') {
      existing = parent[list].find(i => i.did === child.did);
    } else if (list === 'floors') {
      existing = parent[list].find(i => i.info.index === child.info.index);
    } else {
      existing = parent[list].find(i => i.id === child.id);
    }
    const eIndex = parent[list].indexOf(existing);
    parent[list][eIndex] = child;
  }
  parent.alerts = aggAlerts(parent[list]);
  parent.overallAlerts = aggOverall(parent.alerts);
  return parent;
}

function removeChildUpdateAlerts(parent, child, list){
  // TODO: this is where we left off. This looks like it will work but nothing is plugged into it yet.
  let existing;
  if (list === 'rooms') {
    existing = parent[list].find(r => r.did === child);
  } else if (list === 'floors') {
    existing = parent[list].find(f => f.info.index === child);
  } else {
    existing = parent[list].find(i => i.id = child);
  }
  const eIndex = parent[list].indexOf(existing);
  existing[list].splice(eIndex, 1);
  parent.alerts = aggAlerts(parent[list]);
  parent.overallAlerts = aggOverall(parent.alerts);
  return parent;
}

function aggAlerts(arr, str){
  return arr.reduce((a, i) => {
    ['days', 'ttp', 'hhm', 'iaq', 'co2'].forEach(x => {
      if (i.alerts && i.alerts[x]) {
        a[x].bad += i.alerts[x].bad;
        a[x].crit += i.alerts[x].crit;
      }
    });
    return a;
  }, {
    days: {bad: 0, crit: 0},
    ttp: {bad: 0, crit: 0},
    hhm: {bad: 0, crit: 0},
    iaq: {bad: 0, crit: 0},
    co2: {bad: 0, crit: 0}
  })
}

function aggOverall(alerts){
  return Object.keys(alerts).reduce((a, i) => {
    if (i.crit) {
      a.crit += i.crit;
    } else if (i.bad) {
      a.bad += i.bad;
    }
    return a;
  }, {crit: 0, bad: 0});
}

class EmptyAlerts {
  constructor(){
    const self = this;
    const rdgs = ['days', 'ttp', 'hhm', 'iaq', 'co2'];
    rdgs.forEach(i => self[i] = {bad: 0, crit: 0});
  }
}

function formatRoom(room){
  return {
    alerts: new EmptyAlerts(),
    overallAlerts: {bad: 0, crit: 0},
    id: room.id,
    did: room.device,
    meas: ['days', 'ttp', 'hhm', 'iaq', 'co2'].reduce((a, i) => {
      a[i] = '-';
      return a;
    }, {}),
    info: ['altConfig', 'altSize', 'apid', 'device', 'fBrand', 'fModel', 'floorIndex', 'floorName', 'fBrand', 'fModel', 'fType', 'hardwareVersion', 'hvacName', 'manufacturer', 'modelNumber']
      .reduce((a, i) => {
        if (room[i]) {
          a[i] = room[i]
        }
        return a;
      }, {})
  }
}



// WEBPACK FOOTER //
// ./src/store/rest.js